var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a;
import { REACT_APP__URL_SMP_API } from "@smp/utils";
import { apiRequest } from "../../../lib";
export class ApiSmpArtGalleryCanva {
}
_a = ApiSmpArtGalleryCanva;
/**
 * Used to create new CanvaDesign
 */
ApiSmpArtGalleryCanva.create = ({ design_id, export_url, }) => apiRequest({
    body: { design_id, export_url },
    endpoint: REACT_APP__URL_SMP_API + "/art-gallery/v1/canva/",
    method: "POST",
});
/**
 * Used to delete existing CanvaDesign by id
 */
ApiSmpArtGalleryCanva.destroy = ({ id, }) => apiRequest({
    endpoint: REACT_APP__URL_SMP_API + `/art-gallery/v1/canva/${id}`,
    method: "DELETE",
});
/**
 * Used to list existing CanvaDesigns
 */
ApiSmpArtGalleryCanva.list = () => __awaiter(void 0, void 0, void 0, function* () {
    return (yield apiRequest({
        endpoint: REACT_APP__URL_SMP_API + "/art-gallery/v1/canva/",
        method: "GET",
    })).results;
});
/**
 * Used to update existing CanvaDesign
 */
ApiSmpArtGalleryCanva.update = ({ design_id, export_url, id, }) => apiRequest({
    body: { design_id, export_url },
    endpoint: REACT_APP__URL_SMP_API + `/art-gallery/v1/canva/${id}`,
    method: "PUT",
});
//# sourceMappingURL=canva.js.map